export default __webpack_public_path__ + "static/char-08-c009a28cd3c87265f1497063688a1bfb.webp";